import {MobileTHead} from '@/components/commons/table/mobile-t-head/MobileTHead'
import {TableProps} from '@components/commons/table/Table.tsx'
import {MobileTBody} from '@components/commons/table/mobile-t-body/MobileTBody'
import {StyledMobileTable} from '@/components/commons/table/mobile-table/style'

export const MobileTable = <TData extends unknown[], TSortName extends string | undefined>({
    columns,
    data,
    isError,
    expandedRows,
    isChangingPage,
    isLoading,
    onChangePage,
    sorter,
    subRow,
    selectedRowIndex,
    onClickRow
}: TableProps<TData, TSortName>) => {
    return (
        <StyledMobileTable $isSorter={!!sorter}>
            {sorter && <MobileTHead columns={columns} sorter={sorter} />}
            <MobileTBody
                columns={columns}
                data={data}
                isError={isError}
                expandedRows={expandedRows}
                isChangingPage={isChangingPage}
                isLoading={isLoading}
                onChangePage={onChangePage}
                subRow={subRow}
                selectedRowIndex={selectedRowIndex}
                onClickRow={onClickRow}
            />
        </StyledMobileTable>
    )
}

MobileTable.displayName = 'MobileTable'
